import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DatiqButtonModule } from '@dat/datiq-components-pkg/button';
import { DatiqGraphCardModule } from '@dat/datiq-components-pkg/graph-card';
import { DatiqIconsModule } from '@dat/datiq-components-pkg/icons';
import { DatiqPanelModule } from '@dat/datiq-components-pkg/panel';
import { DatiqPanelPopupModule } from '@dat/datiq-components-pkg/panel-popup';
import { DatiqUtilsDirectiveModule } from '@dat/datiq-components-pkg/utils';
import { DatiqCellChangeComponent } from './components/datiq-cell-change/datiq-cell-change.component';
import { DatiqCellExpandableComponent } from './components/datiq-cell-expandable/datiq-cell-expandable.component';
import { DatiqCellGraphValueComponent } from './components/datiq-cell-graph-value/datiq-cell-graph-value.component';
import { DatiqCellHeaderSortComponent } from './components/datiq-cell-header-sort/datiq-cell-header-sort.component';
import { DatiqCellLabelComponent } from './components/datiq-cell-label/datiq-cell-label.component';
import { DatiqCellLaneComponent } from './components/datiq-cell-lane/datiq-cell-lane.component';
import { DatiqCellLocationComponent } from './components/datiq-cell-location/datiq-cell-location.component';
import { DatiqCellPopupFormComponent } from './components/datiq-cell-popup-form/datiq-cell-popup-form.component';
import { DatiqCellPopupComponent } from './components/datiq-cell-popup/datiq-cell-popup.component';
import { DatiqCellTitleComponent } from './components/datiq-cell-title/datiq-cell-title.component';
// import { ScrollingModule as ExperimentalScrollingModule } from '@angular/cdk-experimental/scrolling';
import { ScrollingModule } from '@angular/cdk/scrolling';

const components = [
    DatiqCellTitleComponent,
    DatiqCellLabelComponent,
    DatiqCellChangeComponent,
    DatiqCellGraphValueComponent,
    DatiqCellExpandableComponent,
    DatiqCellHeaderSortComponent,
];

@NgModule({
    declarations: [
        ...components,
        DatiqCellLocationComponent,
        DatiqCellPopupComponent,
        DatiqCellLaneComponent,
        DatiqCellPopupFormComponent,
    ],
    exports: [
        ...components,
        DatiqCellLocationComponent,
        DatiqCellPopupComponent,
        DatiqCellLaneComponent,
        DatiqCellPopupFormComponent,
    ],
    imports: [
        CommonModule,
        MatIconModule,
        DatiqIconsModule,
        DatiqGraphCardModule,
        DatiqPanelModule,
        DatiqButtonModule,
        MatButtonModule,
        DatiqUtilsDirectiveModule,
        MatTooltipModule,
        DatiqPanelPopupModule,
        ScrollingModule,
        // ExperimentalScrollingModule,
    ],
})
export class DatiqTableModule {}
